<template>
    
  <!-- Modal for entering/updating wallet address -->
  <div
    class="modal crypto_pay_input_wallet_add_modal fade"
    id="crypto_pay_input_wallet_add_modal"
  >
    <div class="modal-dialog">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">{{ translate('Your USDT (TRC20) Wallet Address') }}</h3>
          <div class="box-tools pull-right">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click="closeWalletModal"
            >
              &times;
            </button>
          </div>
        </div>
        <form class="form-horizontal" @submit.prevent="updateWallet">
          <div class="box-body">
            <div class="form-group">
              <label for="usdt_wallet" class="col-sm-4 control-label">
                {{ translate('USDT TRC20 Wallet') }}
              </label>
              <div class="col-sm-8">
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'has-error': walletError }"
                  id="usdt_wallet"
                  :placeholder="translate('Wallet Address (TRC20)')"
                  v-model="walletAddress"
                  required
                />
                <span v-if="walletError" class="invalid-feedback" role="alert">
                  <strong>{{ walletErrorMessage }}</strong>
                </span>
                <div
                  id="wrong-add"
                  class="invalid-feedback"
                  v-show="wrongAdd"
                >
                  {{ translate('Incorrect TRC20 Wallet Address Format') }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 control-label"></label>
              <div class="col-sm-8">
                <button type="submit" class="btn btn-primary" style="margin-right: 10px;">
                  {{ translate('Insert') }}
                </button>
                <a class="btn btn-danger" id="cancel_update_wallet" @click.prevent="cancelWalletUpdate">
                  {{ translate('Back') }}
                </a>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </form>
      </div>
    </div>
  </div>

  <!-- Modal for crypto payment -->
  <div
    class="modal crypto_pay_modal fade"
    data-backdrop="static"
    data-keyboard="false"
    id="crypto_pay_modal"
  >
    <div class="modal-dialog">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">{{ translate('Pay with Tether USDT (TRC20)') }}</h3>
          <div class="box-tools pull-right">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click.prevent="closeCryptoModal"
            >
              &times;
            </button>
          </div>
        </div>
        <div class="box-body">
          <div class="alert alert-danger" v-if="flashRedMessage" v-html="flashRedMessage"></div>
          <div class="alert alert-success" v-if="flashGreenMessage" v-html="flashGreenMessage"></div>
          <div class="text-muted well well-sm no-shadow">
            <h4 class="text-center">{{ translate('Payment Information') }}</h4>
          </div>
          <div class="card-body">
            <table class="table no-border table-responsive">
              <tbody>
                <tr>
                  <td width="30%" class="text-right">{{ translate('Status') }}:</td>
                  <td width="70%" id="payment_status" v-html="paymentStatus"></td>
                </tr>
                <tr>
                  <td class="text-right">{{ translate('Total Amount') }}:</td>
                  <td>{{ product_usdt.Price }} USDT</td>
                </tr>
                <tr>
                  <td class="text-right">{{ translate('QR Code') }}:</td>
                  <td>
                    <div
                      v-if="qrCodeUrl"
                      style="max-height: 200px; max-width: 200px; overflow: hidden;"
                    >
                      <img id="qrcode2" :src="qrCodeUrl" alt="QR Code"/>
                    </div>
                    <div v-else>
                      {{ translate('QR Code not generated, click edit and save button to generate QR Code') }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="text-right">{{ translate('Wallet Address') }}:</td>
                  <td class="wallet_add">
                    <div style="display: inline;" id="codeBlock_php1">
                      {{ usdtWalletConfig }}
                    </div>
                    <i
                      id="php1_btn"
                      class="fa fa-clone js-tooltip js-copy"
                      data-toggle="tooltip"
                      title="Copy to clipboard"
                      @click="copyWalletAddress"
                      style="margin-left:5px"
                    ></i>
                  </td>
                </tr>
                <tr>
                  <td class="text-right">{{ translate('Your Wallet Address') }}:</td>
                  <td class="wallet_add">
                    <div id="client_wallet_add" style="display: inline;">
                      {{ usdtUserWallet ? usdtUserWallet : '-' }}
                    </div>
                    -
                    <a href="#" id="edit_wallet_address" @click.prevent="editWalletAddress">
                      {{ translate('edit') }}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td class="text-right">{{ translate('Session Time') }}:</td>
                  <td class="wallet_add" id="countdown">
                    {{ countdownDisplay }}
                  </td>
                </tr>
                <tr>
                  <td class="text-right">{{ translate('Remark') }}:</td>
                  <td class="wallet_add" id="remarkMsg">
                    {{ translate('Automated topup once payment receive') }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- /.box-body -->
      </div>
    </div>
  </div>
   
</template>
  
<script>
  export default {
    name: 'Cryptocurrency',
    props: {
      product_usdt: { type: Object, required: true },
      usdtWalletConfig: { type: String, required: true },
      flashRedMessage: { type: String, default: '' },
      flashGreenMessage: { type: String, default: '' },
      qrCodeUrl: { type: String, default: null }, 
      usdtUserWallet: { type: String, default: null }, 
    },
    data() {
      return {
        walletAddress: '',
        walletError: false,
        walletErrorMessage: '',
        wrongAdd: false,
        // usdtUserWallet: '', // will hold the user's wallet address once entered
        paymentStatus: this.translate('Waiting for buyers funds') + '...',
        // Set the countdown to 8 minutes (480 seconds)
        startingMinutes: 2,
        timeLeft: 2 * 60,
        countdownInterval: null,
        users: [],
      };
    },
    computed: {
      countdownDisplay() {
        const minutes = Math.floor(this.timeLeft / 60);
        let seconds = this.timeLeft % 60;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        return `${minutes}:${seconds}`;
      },
      
    },
    mounted() {
        // console.log("Received qrCodeUrl in Cryptocurrency.vue:", this.qrCodeUrl);
        // Initialize any tooltips (using jQuery if available)
        $('.js-tooltip').tooltip();
        // Before the user leaves the page, disconnect Echo
        $(window).on('beforeunload', () => {
            if (typeof Echo !== 'undefined') {
            Echo.disconnect();
            }
        });
    },
    watch: {
        usdtUserWallet(newVal) {
            console.log("updated usdtUserWallet:", newVal);
        }
    },
    methods: {
      initCountdown() {
        console.log('initCountdown()');
        this.timeLeft = this.startingMinutes * 60;
        this.paymentStatus = this.translate('Waiting for buyers funds') + '...';
      },
      updateCountdown() {
        if (this.timeLeft <= 0) {
          this.paymentStatus = `<span style="color: red;">${this.translate("<strong>Session Expired.</strong> Please click 'Pay with USDT' again")}</span>`;
          clearInterval(this.countdownInterval);
        } else {
          this.timeLeft--;
        }
      },
      updateWallet() {
        // Validate that the wallet address starts with "T"
        if (!this.walletAddress.startsWith('T')) {
          console.log('Incorrect TRC20 Wallet Address Format');
          this.wrongAdd = true;
          return;
        } else {
          console.log('Correct TRC20 Wallet Address Format');
          this.wrongAdd = false;
        }
        // Post the wallet update (using jQuery.ajax here; adjust as needed)
        $.post(
          window.routes.updateWallet,
          {
            usdt_wallet: this.walletAddress,
            _token: window.csrfToken
          },
          (data, status) => {
            console.log('post update wallet success, Data: ', data, 'Status:', status);
            if (data === 'failed') {
              alert('Invalid Wallet Address');
              return;
            }
            
            // Emit the new wallet address to the parent
            // console.log("Emitting wallet value:", this.walletAddress);
            this.$emit('update:usdtUserWallet', this.walletAddress);
            // Hide the wallet input modal
            $('#crypto_pay_input_wallet_add_modal').modal('toggle');
            // Automatically trigger the pay USDT action
            // Use $nextTick to ensure the parent's value is updated before calling usdtBtnClicked()
            this.$nextTick(() => {
                this.usdtBtnClicked();
            });
          }
        );
      },
      cancelWalletUpdate() {
        $('#crypto_pay_input_wallet_add_modal').modal('toggle');
      },
      usdtBtnClicked() {
        // Check whether the user is logged in.
        const userID = window.user || null;
        console.log('Click pay USDT button');
        if (!userID) {
            console.log('not logged in');
          window.location.href = window.routes.login;
          return;
        }
        if (!this.usdtUserWallet) {
          console.log('wallet is empty');
          this.walletAddress = '';
          $('#crypto_pay_input_wallet_add_modal').modal();
          this.wrongAdd = false;
          return;
        }
        this.initCountdown();
        // Show the crypto modal and start the countdown
        $('#crypto_pay_modal').modal();
        console.log("opened modal");
        this.countdownInterval = setInterval(this.updateCountdown, 1000);
        // Connect to Echo and join the channel
        if (typeof Echo !== 'undefined') {
          Echo.connect();
          Echo.join('showing_USDT_QR_Code')
            .here(users => {
              console.log('here', users);
              this.users = users;
              // Post to capture the product currently showing (for example)
              $.post(
                window.routes.captureProductShowing_USDT_QR_Code,
                {
                  product: this.product_usdt,
                  _token: window.csrfToken
                },
                (data, status) => {
                  console.log('post captureProductShowing_USDT_QR_Code success, Data: ', data, 'Status:', status);
                }
              );
            })
            .joining(user => {
              console.log('joining', user);
              this.users.push(user);
            })
            .leaving(user => {
              console.log('leaving', user);
              this.users = this.users.filter(u => u.id !== user.id);
            })
            .listen('onShowing_USDT_QR_Code', event => {
              console.log('on listen, event = ', event);
            });
        }
      },
      closeCryptoModal() {
        console.log('close USDT_QR_Code modal');
        if (typeof Echo !== 'undefined') {
          Echo.disconnect();
        }
        $.get(window.routes.leaveShowing_USDT_QR_Code, (data, status) => {
          console.log('get success, Data: ', data, 'Status:', status);
        });
        clearInterval(this.countdownInterval);
        $('#crypto_pay_modal').modal('toggle');
      },
      closeWalletModal() {
        $('#crypto_pay_input_wallet_add_modal').modal('toggle');
      },
      editWalletAddress() {
        console.log('edit wallet address clicked');
        this.closeCryptoModal();
        this.walletAddress = '';
        $('#crypto_pay_input_wallet_add_modal').modal();
      },
      copyWalletAddress() {
        const text = document.getElementById('codeBlock_php1').innerText;
        const el = $('#php1_btn');
        this.copyToClipboard(text, el);
      },
      copyToClipboard(text, el) {
        const copyTest = document.queryCommandSupported('copy');
        const originalTitle = el.attr('data-original-title') || 'Copy to clipboard';
        if (copyTest === true) {
          const copyTextArea = document.createElement('textarea');
          copyTextArea.value = text;
          document.body.appendChild(copyTextArea);
          copyTextArea.select();
          try {
            const successful = document.execCommand('copy');
            const msg = successful ? 'Copied!' : 'Whoops, not copied!';
            el.attr('data-original-title', msg).tooltip('show');
          } catch (err) {
            console.log('Oops, unable to copy');
          }
          document.body.removeChild(copyTextArea);
          el.attr('data-original-title', originalTitle);
        } else {
          window.prompt('Copy to clipboard: Ctrl+C or Command+C, Enter', text);
        }
      },
      translate(key) {
        return this.$parent.translate(key);
      },
    },
  };
</script>
  